import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, IconButton, Select, Box, MenuItem, InputLabel, FormControl, useTheme
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { tokens } from "../../../theme/theme";
import ClearIcon from '@mui/icons-material/Clear';

const NewDepartmentDialog = ({ open, onClose, onAdd, onClear, newDepartment, handleInputChange }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isAddDisabled = !newDepartment.DepartmentCode || !newDepartment.DepartmentCodeDesc;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    margin: '0px', // Adjust as needed
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
                New Department
            </DialogTitle>
            <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <TextField
                    autoFocus
                    margin="dense"
                    name="DepartmentCode"
                    size='small'
                    label="Department Code"
                    fullWidth
                    value={newDepartment.DepartmentCode}
                    onChange={handleInputChange}
                    required
                    error={!newDepartment.DepartmentCode}
                    helperText={!newDepartment.DepartmentCode && "Product department Code is required"}
                />
                <TextField
                    margin="dense"
                    name="DepartmentCodeDesc"
                    size='small'
                    label="Department Description"
                    fullWidth
                    value={newDepartment.DepartmentCodeDesc}
                    onChange={handleInputChange}
                    required
                    error={!newDepartment.DepartmentCodeDesc}
                    helperText={!newDepartment.DepartmentCodeDesc && "department Description is required"}
                />
                <FormControl fullWidth margin="dense" size='small'>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="DepartmentCodeStatus"
                        value={newDepartment.DepartmentCodeStatus}
                        onChange={handleInputChange}
                    >
                        {/* <MenuItem value=""><em>None</em></MenuItem> */}
                        <MenuItem value="A">Active</MenuItem>
                        <MenuItem value="IA">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
               
                <Box justifyContent={'space-between'} >

                    <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={onAdd}>
                        Save
                    </Button>

                    <Button
                        variant='contained' onClick={onClear}
                        style={{ marginRight: '10px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                    >
                        Clear
                    </Button>

                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewDepartmentDialog;
